var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0v16h16V0z",
    fill: "#fff",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 6.322A9.684 9.684 0 006.5 3.782M12.667 8.6A6.569 6.569 0 009.5 6.838M3.333 8.6c.443-.443.933-.81 1.454-1.1M5.333 10.771A3.754 3.754 0 017 9.801",
    stroke: "#fff",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.333a.833.833 0 100-1.666.833.833 0 000 1.666z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 13.333L2.667 2.667M1.333 6.322A9.768 9.768 0 012.5 5.375",
    stroke: "#fff",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/wifi_closed.0131dd0c.svg";
export { SvgWifiClosed as ReactComponent };